var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.target.type)?_c('gl-link',_vm._b({},'gl-link',_vm.targetLinkAttributes,false),[_vm._v(_vm._s(_vm.targetLinkText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }